import { lazy } from 'react';

const Dashboard = lazy(() => import('./ProcessorDashboardPage'));

const ProcessorDashboardConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'processor/dashboard',
      element: <Dashboard />,
    },
  ],
};

export default ProcessorDashboardConfig;
